import { useFirestoreDocumentData } from '@react-query-firebase/firestore'
import { ICorporateEntityInfo } from './ICorporateEntityInfo'
import { DocumentReference, Firestore, doc } from 'firebase/firestore'

function useGetCorporate(firestore: Firestore, name : string){
	const corporateRef = doc(firestore,`corporate/${name}`) as DocumentReference<ICorporateEntityInfo>
	return useFirestoreDocumentData(['corporate'], corporateRef)
}

export default useGetCorporate